import NotFoundPage from '@/pages/NotFoundPage';
import { isTrue } from '@/utils/validation';

import APP_ROUTES from './APP_ROUTES';
import AbsoluteRedirect from './AbsoluteRedirect';

const getStorybookRoute = (): {
  path: string;
  element: JSX.Element;
} => {
  if (isTrue(import.meta.env.VITE_STORYBOOK)) {
    return {
      path: APP_ROUTES.storybook,
      element: <AbsoluteRedirect to={`/storybook-static/index.html`} />,
    };
  }
  return {
    path: APP_ROUTES.storybook,
    element: <NotFoundPage />,
  };
};

export default getStorybookRoute;
